export default "__VITE_ASSET__604af3ec__"